'use strict';

import * as monaco from "monaco-editor";


export default class MonacoEditorHelper {
    initializeMonacoEditor(textarea, filename) {
        if (!textarea) {
            console.warn("Textarea not found for Monaco Editor.");
            return;
        }

        // Create a container for Monaco
        const container = document.createElement('div');
        container.id = 'monaco-container';
        container.style.height = '800px';
        container.style.width = '100%';
        container.style.border = '1px solid #ccc';

        // Replace the `<textarea>` with Monaco
        textarea.style.display = 'none';
        textarea.parentNode.appendChild(container);

        // Detect the language
        const language = this.detectLanguage(textarea.value, filename);

        // Initialize Monaco with the content of the `<textarea>`
        const monacoEditorInstance = monaco.editor.create(container, {
            value: textarea.value,
            language: language,
            theme: 'vs-dark',
            automaticLayout: true
        });

        return monacoEditorInstance;
    }
    /**
     * Detect the language based on the content or filename
     */
    detectLanguage(content, filename) {
        if (filename) {
            const extension = filename.split('.').pop().toLowerCase();
            switch (extension) {
                case 'js':
                case 'jsx':
                    return 'javascript';
                case 'ts':
                    return 'typescript';
                case 'json':
                    return 'json';
                case 'html':
                case 'htm':
                    return 'html';
                case 'css':
                    return 'css';
                case 'scss':
                    return 'scss';
                case 'ini':
                    return 'ini';
                case 'xml':
                    return 'xml';
                case 'yml':
                case 'yaml':
                    return 'yaml';
                case 'md':
                    return 'markdown';
                case 'php':
                    return 'php';
                case 'sh':
                case 'bash':
                    return 'shell';
                case 'sql':
                    return 'sql';
                case 'py':
                    return 'python';
                case 'go':
                    return 'go';
                default:
                    return 'ini';
            }
        }

        // 🟢 Fallback detection by content
        if (content.trim().startsWith('{')) return 'json';
        if (content.trim().startsWith('<html>')) return 'html';
        if (content.includes('[') && content.includes(']')) return 'ini';
        if (content.includes('<?php')) return 'php';
        if (content.includes('function') || content.includes('const')) return 'javascript';

        return 'ini';
    }
}